import LOCAL_STORAGE_KEYS from './localStorageKeys';
import base_url from '../baseUrls';
import {handleAuthFailure} from './authFailure';

const axios = require('axios').default;

// Shared across all concurrent getAccessToken callers, see below.
let refreshPromise = null;


const ApiUtils = {
  isDevelopment: ()=> {
    return process.env.NODE_ENV === 'development';
  },
  isStaging: ()=> {
    return process.env.NODE_ENV === 'staging';
  },
  isMockMode: ()=> {
    return process.env.NODE_ENV === 'development' && process.env.REACT_APP_MODE === 'mock';
  },
  getAccessToken: async () => {

    try {
      const tokensString = localStorage.getItem(LOCAL_STORAGE_KEYS.tokens);
      if (!tokensString || tokensString === 'undefined') {
        return undefined;
      }

      const tokens = JSON.parse(tokensString);

      if (tokens.accessToken.expiresAtMs - Date.now() < 60000) {    
        //console.log('need to get new token');
        // Less than 1 min left for expiration, so we refetch first and then send.

        // Concurrent callers must share one request. A second refresh carrying the
        // already rotated access token is read by the server as a stolen token, and
        // it deletes the token pair, which signs the user out for good.
        if (!refreshPromise) {
          refreshPromise = ApiUtils.requestNewAccessToken(tokens.accessToken.token, `Bearer ${tokens.refreshToken}`)
            .finally(() => {
              refreshPromise = null;
            });
        }

        let newAccessToken = await refreshPromise;

        tokens.accessToken = newAccessToken.accessToken;
        tokens.refreshToken = newAccessToken.refreshToken;
        localStorage.setItem(LOCAL_STORAGE_KEYS.tokens, JSON.stringify(tokens));

        return `Bearer ${newAccessToken.accessToken.token}`;
      } else {

        return `Bearer ${tokens.accessToken.token}`;
      }
    } catch (error) {
      console.error('Error when getting the access token', error);
      throw error;
    }
  },
  /**
   * Requests a new access token from a server
   * @param accessToken Access token for server validation
   * @param refreshToken Refresh token that is used to get a new access token
   * @param skipThrows If set to true, will skip all the throws, used in axiosConfig. Since we need to call this
   * when we get invalid access token or refresh token(Server needs this to potentially log some malicious activities)
   * setting this to true will prevent an infinite loop situation.
   * @returns promise containing the new access token
   */
  requestNewAccessToken: async (accessToken, refreshToken, skipThrows) => {
    try {
      // console.log('Request tokens');

      //console.log('current access token info');
      //console.log(accessToken);
    

      const response = await axios.post(`${base_url.api}users/token`, {accessToken},
        {
          headers: {
            'Authorization': refreshToken,
          },
        }
      );
      //console.log("===>" , response)
      if (skipThrows) {
        return;
      }
      // const tokensAreValid = await validator.tokensAreValid(response.data.data.tokenPair);
      //   if(!tokensAreValid) {
      //     throw {"status": "error",
      //     "errorCode": ERROR_CODES.GET_INVALID_TOKEN_PAIR,
      //     "message": "Server return invalid token object"};
      // }

      return response.data.data.tokenPair;
    } catch(error) {
      console.error('Error while requesting access code', error);
      if (!skipThrows) {
        throw error.response?.data ?? error;
      }
    }
  },
  /**
   *
   * @param {string} method
   * @param {string} endpoint
   * @param {string|undefined} payload
   * @return {Promise}
   */
  makeApiCall: async (method, endpoint, payload)=> {
    const authToken = await ApiUtils.getAccessToken();
    if(!authToken) {
      return;
    }
    const url = `${base_url.api}${endpoint}`;

    const params = {
      method: method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: authToken,
      },
    };
    if(payload) {
      params.body = payload;
    }
    const response = await fetch(
      url,
      params
    );
    try {
      let result = await response.json();

      // fetch does not go through the axios interceptor, so the same check runs here.
      handleAuthFailure(result?.errorCode);

      return result;
    }
    catch 
    {
      return { status: 'error', errorCode: 'unknown error', message: 'unknown error ***'};
    }
  }
};

export default ApiUtils;
